import { render, staticRenderFns } from "./PanelContainer.vue?vue&type=template&id=36e31a6a&scoped=true&"
import script from "./PanelContainer.vue?vue&type=script&lang=js&"
export * from "./PanelContainer.vue?vue&type=script&lang=js&"
import style0 from "./PanelContainer.vue?vue&type=style&index=0&id=36e31a6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e31a6a",
  null
  
)

export default component.exports